export const HEADERS = [
	'No',
	'Consultant',
	'Total',
	'Delivered',
	'Delivery percent',
	'Stars',
	'Listening',
];
